import {
  CHANGE_INPUT_VALUE,
  GOLD_MIGRATION_LOGIN_REQUEST,
  GOLD_MIGRATION_LOGIN_REQUEST_FAILURE,
  GOLD_MIGRATION_LOGIN_REQUEST_SUCCESS,
  REDIRECT_TO_PAYMENTS_PAGE,
  RESET_FORM_ERRORS,
  SET_GOLD_MIGRATION_COOKIES,
  UPDATE_GOLD_MIGRATION_SESSION,
  UPDATE_IS_USERNAME_REQUIRED,
  UPDATE_PROFILE_TRANSFER_STEP,
} from './constants';

export function changeInputValue({ field, value }) {
  return {
    payload: { field, value },
    type: CHANGE_INPUT_VALUE,
  };
}

export function goldMigrationLoginRequest({
  operation,
  password,
  username,
  usernameForLogin,
}) {
  return {
    payload: {
      operation,
      password,
      username,
      usernameForLogin,
    },
    type: GOLD_MIGRATION_LOGIN_REQUEST,
  };
}

export function goldMigrationLoginRequestFailure({ formErrors, fullError }) {
  return {
    payload: { formErrors, fullError },
    type: GOLD_MIGRATION_LOGIN_REQUEST_FAILURE,
  };
}

export function goldMigrationLoginRequestSuccess() {
  return { type: GOLD_MIGRATION_LOGIN_REQUEST_SUCCESS };
}

export function redirectToPaymentsPage() {
  return { type: REDIRECT_TO_PAYMENTS_PAGE };
}

export function resetFormErrors() {
  return { type: RESET_FORM_ERRORS };
}

export function setGoldMigrationCookies({
  goldMigrationPLGeneralLogin,
  goldMigrationPLPreLogin,
  goldMigrationPLProfileTransfer,
}) {
  return {
    payload: {
      goldMigrationPLGeneralLogin,
      goldMigrationPLPreLogin,
      goldMigrationPLProfileTransfer,
    },
    type: SET_GOLD_MIGRATION_COOKIES,
  };
}

export function updateGoldMigrationSession(payload) {
  return {
    payload,
    type: UPDATE_GOLD_MIGRATION_SESSION,
  };
}

export function updateIsUsernameRequired(payload) {
  return {
    payload,
    type: UPDATE_IS_USERNAME_REQUIRED,
  };
}

export function updateProfileTransferStep(step) {
  return {
    payload: { step },
    type: UPDATE_PROFILE_TRANSFER_STEP,
  };
}
